export default (isWidthDown, width) => {
  if (isWidthDown('sm', width)) {
    return 3;
  }

  return 10;
};
